import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { DrawerTitle } from '../PowerTakeOff.style'

export const StyledDrawerTitle = styled(DrawerTitle)`
  font-size: 24px;
  font-weight: bold;
  color: ${themeColor('blackPrimary')};
  padding: 12px 18px;
  background: ${themeColor('whitePrimary')};
  border-bottom: solid 1px ${themeColor('grey')};
  margin: 0;
`
